._footer_ltf0n_1 {
  padding: 12px 24px 32px 24px;
  display: flex;
  align-items: center;
  flex-direction: column; }

._title_ltf0n_7 {
  color: #7a92a5;
  margin-bottom: 16px; }

._title_ltf0n_7 .control-label-base.t21 {
  color: inherit; }

.classic-facelift-skin ._title_ltf0n_7 {
  color: #868aa5; }
